import { h } from 'preact';

const WolficonAlert = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M506.82 425.56L289 48.31a38.11 38.11 0 00-66 0L5.18 425.56a38.11 38.11 0 0033 57.19H473.8a38.11 38.11 0 0033-57.19zM277 417.64h-43.34v-45.35H277zm-4.09-67.18h-35.15l-6.14-179.37h45.69z" />
    </svg>
);

export default WolficonAlert;
